/**
 * 入住人模块
 */
import React, { memo } from 'react';
import { connect } from 'react-redux';

import { createStateSelector } from '@/redux/actions/reservation/helper';
import {
  handleAddGuestItem,
  handleDeleteGuestItem,
  handleGuestItemChange,
  handleSetGuestToOwner,
  handleClearGuestItem,
  getAllGuestList,
  setLoadingStatus,
  setCardNotice,
} from '@/redux/actions/reservation/checkIn';
import { ReducerState, storeName } from '@/redux/reducers/reservation/checkIn';
import GuestList from '@/pages/reservation/checkIn/components/GuestInfo';
import { getPopupContainer } from '@/pages/reservation/checkIn/checkIn/helper';
import { trackIDCardReader, IDCardReaderScene } from '@/utils/monitor';

const stateSelector = (state: ReducerState, globalStore) => {
  const { allGuestList } = state;
  const { memberLevelMap } = globalStore.guest;
  return { allGuestList, memberLevelMap };
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
const mapDispatchToProps = {
  callItemAdd: handleAddGuestItem,
  callItemDelete: handleDeleteGuestItem,
  callItemChange: handleGuestItemChange,
  callClearItem: handleClearGuestItem,
  callSetToOwner: handleSetGuestToOwner,
  callGetList: getAllGuestList,
  callSetLoading: setLoadingStatus,
  callSetNotice: setCardNotice,
};

type MapStateProps = ReturnType<typeof stateSelector>;
type MapDispatchProps = typeof mapDispatchToProps;

interface IProps extends MapStateProps, MapDispatchProps {
  isAppendMode: boolean;
}

const Index: React.FC<IProps> = (props) => {
  const {
    isAppendMode,
    allGuestList,
    memberLevelMap,
    callItemAdd,
    callItemDelete,
    callItemChange,
    callClearItem,
    callSetToOwner,
    callGetList,
    callSetLoading,
    callSetNotice,
  } = props;

  // 身份证读取回调
  const handleIDCardReadSuccess = () => {
    trackIDCardReader({
      type: isAppendMode ? IDCardReaderScene.ExtendCheckIn : IDCardReaderScene.NewCheckIn,
    });
  };

  return (
    <GuestList
      autoCheckReserve={!isAppendMode}
      isMasterReadOnly={isAppendMode}
      guestList={allGuestList}
      memberLevelMap={memberLevelMap}
      onAddItem={callItemAdd}
      onItemDelete={callItemDelete}
      onItemChange={callItemChange}
      onSetToOwner={callSetToOwner}
      onItemClear={callClearItem}
      getItemList={callGetList}
      getPopContainer={getPopupContainer}
      setLoadingStatus={callSetLoading}
      setNoticeContent={callSetNotice}
      onIDCardReadSuccess={handleIDCardReadSuccess}
    />
  );
};

export default connect<MapStateProps, MapDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(memo(Index));
